import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq-titulo" className="w-full bg-white py-16 sm:py-24" data-id="element-45" data-mp="1lc231ky1rhuv">
      <div className="mx-auto w-full max-w-3xl px-5 sm:px-8" data-id="element-46" data-mp="1ge8w2pox6jtj">
        <h2 id="faq-titulo" className="font-display text-3xl font-extrabold uppercase leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-47" data-mp="2e0pqnn69qjbl">
          Preguntas frecuentes
        </h2>

        <ul className="mt-8 divide-y divide-sand-200 border-y border-sand-200" data-id="element-48" data-mp="2418npdieijjb">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.q} data-id="element-49" data-mp="snd51usafsnc" data-mpi={index}>
                <button type="button" aria-expanded={isOpen} onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-4 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ember-500" data-id="element-50" data-mp="soo79q634scc">
                  <span className="font-display text-lg font-bold text-ink" data-id="element-51" data-mp="fiyr3x09dy4s">{faq.q}</span>
                  <PlusIcon aria-hidden="true" className="h-5 w-5 shrink-0 text-ember-600 transition-transform duration-150 ease-out" style={{
                transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)'
              }} data-id="element-52" data-mp="khtgjhsqekxv" />
                </button>
                <AnimatePresence initial={false} data-id="element-53" data-mp="3szzf09stm6rz">
                  {isOpen && <motion.div key="content" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-54" data-mp="1rka1vpww70d">
                      <p className="pb-5 pr-8 text-base leading-relaxed text-ink/70" data-id="element-55" data-mp="1ppuoknrllnmh">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}